import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { jsx as _jsx } from "react/jsx-runtime";
export const RecommendationsGrid = ({
  children
}) => {
  const {
    isDesktop
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(CardGrid, {
    gridTemplateColumns: isDesktop ? 'repeat(3, 1fr)' : '1fr',
    gutterSize: 24,
    children: children
  });
};